import { ReactElement } from 'react';
import {
  Control,
  Controller,
  ControllerProps,
  FieldValues,
} from 'react-hook-form';
import { Switch, SwitchProps } from '~/index.ts';

interface ExtendedProps<T extends FieldValues> {
  name: ControllerProps<T>['name'];
  // Control prop from the react-hook-form's 'useForm'
  control: Control<T>;
  defaultValue?: ControllerProps<T>['defaultValue'];
}

export type HookFormSwitchProps<T extends FieldValues> = ExtendedProps<T> &
  SwitchProps;

const HookFormSwitch = <T extends FieldValues>(
  props: HookFormSwitchProps<T>,
): ReactElement => {
  const { name, control, defaultValue, ...switchProps } = props;

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ field }) => {
        const { value, onChange } = field;
        return (
          <Switch
            {...switchProps}
            {...field}
            checked={value}
            onChange={(e, checked) => {
              onChange(e, checked);
              props.onChange && props.onChange(e, checked);
            }}
          />
        );
      }}
    />
  );
};

export default HookFormSwitch;
